import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { CampaignsTab } from '../../components/CampaignsTab';

const CampaignsIndex = () => {
  const navigate = useNavigate({ from: '/campaigns' });

  const openCampaign = (campaignId: string) =>
    navigate({ search: prev => ({ ...prev, campaignId }) });

  return <CampaignsTab onOpenCampaign={openCampaign} />;
};

export const Route = createFileRoute('/campaigns/')({
  component: CampaignsIndex
});
